import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { errorBoundary, sendTelemetryErrorEvent } from '~common/react/components/ErrorBoundary';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { clearSpaceContentCountsAction } from '~src/spacesPlatform/actions/ContentCountsActions';
import { showContentTypes } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '~src/spacesPlatform/selectors/ContentFilterSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapDispatchToProps,MapStateToProps } from '../../../app/utils/ConnectUtils';
import {
  SharedWithMeSpace,
  SharedWithMeSpaceDispatchProps,
  SharedWithMeSpaceOwnProps,
  SharedWithMeSpaceStateProps} from './SharedWithMeSpace';

const mapStateToProps: MapStateToProps<SharedWithMeSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<SharedWithMeSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction
  }, dispatch);

const ConnectedSharedWithMeSpaceInternal: React.ComponentClass<SharedWithMeSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(SharedWithMeSpace);

export const ConnectedSharedWithMeSpace = errorBoundary<SharedWithMeSpaceOwnProps>
  (sendTelemetryErrorEvent)(ConnectedSharedWithMeSpaceInternal);
